module.exports = __webpack_public_path__ + "img/fr_failure_7.2d16afe2.png";